/**
 * A versioned legal document shown on mijn.chargee.energy. The version is what
 * participants accept and what the programs API stores with their consent, so a
 * new revision gets a new version and users are asked to accept again.
 */

/** A paragraph, or a bulleted list when it is an array. */
export type TermsBlock = string | string[]

export interface TermsArticle {
  /** Anchor for links into the document, e.g. "beloning". */
  id: string
  title: string
  blocks: TermsBlock[]
}

export interface TermsDocument {
  title: string
  /** Matches the version in api/src/programs/definitions.ts. */
  version: string
  /** Date this revision applies from, ISO. */
  revisionDate: string
  intro: string[]
  articles: TermsArticle[]
}

/** Chargee B.V. as in the general terms (revision 12 August 2026). */
export const CHARGEE_ENTITY = {
  name: 'Chargee B.V.',
  seat: 'Valkenswaard',
  address: 'Torenallee 34, 5617 BD Eindhoven',
  kvk: '88555461',
  support: 'https://support.chargee.energy',
  contact: 'https://www.chargee.energy/nl/contact',
  terms: 'https://www.chargee.energy/nl/terms',
  privacy: 'https://www.chargee.energy/nl/privacy',
} as const

/** Where the pilot's documents live on mijn.chargee.energy (and every brand domain). */
export const NET_BEWUST_TERMS_PATH = '/voorwaarden/net-bewust-thuis-laden'
export const NET_BEWUST_DATA_SHARING_PATH = '/voorwaarden/net-bewust-thuis-laden/gegevens-delen'
